// Components
import PasswordResetLinkController from '@/actions/App/Http/Controllers/Admin/Auth/PasswordResetLinkController';
import { Spinner } from '@/components/ui/spinner';
import { login } from '@/routes/admin';
import { Form, Head } from '@inertiajs/react';

import InputError from '@/components/shared/input-error';
import TextLink from '@/components/shared/text-link';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import AuthLayout from '@/layouts/auth-layout';

export default function ForgotPassword({ status }: { status?: string }) {
    return (
        <AuthLayout
            title="Forgot password"
            description="Enter your email to receive a password reset link"
        >
            <Head title="Forgot password" />

            {status && (
                <div className="mb-4 text-center text-sm font-medium text-green-600">
                    {status}
                </div>
            )}

            <Card className="w-full">
                <CardContent className="p-6 sm:p-8">
                    <div className="space-y-6">
                        <Form
                            action={PasswordResetLinkController.store.url()}
                            method="post"
                        >
                            {({ processing, errors }) => (
                                <>
                                    <div className="grid gap-2">
                                        <Label htmlFor="email">
                                            Email address
                                        </Label>
                                        <Input
                                            id="email"
                                            type="email"
                                            name="email"
                                            autoComplete="off"
                                            autoFocus
                                            placeholder="email@example.com"
                                        />

                                        <InputError message={errors.email} />
                                    </div>

                                    <div className="my-6 flex items-center justify-start">
                                        <Button
                                            className="w-full cursor-pointer"
                                            disabled={processing}
                                            data-test="email-password-reset-link-button"
                                        >
                                            {processing && (
                                                <Spinner className="h-4 w-4" />
                                            )}
                                            Send Reset Link
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Form>

                        <div className="space-x-1 text-center text-sm text-muted-foreground">
                            <span>Back to</span>
                            <TextLink href={login()}>Sign in</TextLink>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </AuthLayout>
    );
}
